import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { alpha } from "@mui/material/styles"

import NewFeatureChip from "../../../common/components/NewFeatureChip"
import Row from "../../../common/components/Row"

export function TeamTabLabel() {
  return (
    <Row sx={{ alignItems: "center", gap: 0.5 }}>
      Team
      <NewFeatureChip label="New" size="small" />
    </Row>
  )
}

export function TeamFeatureBanner({ activeMemberCount = 0 }) {
  const hasMembers = activeMemberCount > 0
  return (
    <Box sx={{ width: "100%" }}>
      <Row
        sx={{
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 2,
          flexWrap: "wrap",
          mb: 1.25,
        }}
      >
        <Row sx={{ alignItems: "center", gap: 1.25 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "12px",
              display: "grid",
              placeItems: "center",
              backgroundColor: (theme) =>
                alpha(theme.palette.secondary.main, 0.1),
              color: "secondary.main",
            }}
          >
            <GroupAddOutlinedIcon fontSize="small" />
          </Box>
          <NewFeatureChip label="New feature" size="small" />
        </Row>
        {hasMembers && (
          <Box
            sx={{
              minWidth: 88,
              px: 1.75,
              py: 1.25,
              borderRadius: "12px",
              textAlign: "center",
              backgroundColor: (theme) =>
                alpha(theme.palette.secondary.main, 0.06),
              border: "1px solid",
              borderColor: (theme) => alpha(theme.palette.secondary.main, 0.14),
            }}
          >
            <Typography
              variant="h5"
              sx={{ fontWeight: 800, lineHeight: 1.1, color: "text.primary" }}
            >
              {activeMemberCount}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              active
            </Typography>
          </Box>
        )}
      </Row>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          letterSpacing: "-0.01em",
          mb: 0.75,
          color: "text.primary",
        }}
      >
        Team access
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ lineHeight: 1.65, width: "100%" }}
      >
        Invite assistants and colleagues to work in your OneBase account. Each
        person uses their own login. Their name appears on calls, SMS, and
        meetings in the activity timeline.
      </Typography>
    </Box>
  )
}
